<template>
    <div> <el-cascader ref="refCascader" placeholder="请选择服务单类型" :options="productTypeSlectOption" size="200"
            style="width: 400px;" :value="productTypeUidSelected" :defaultValue="defaultValue"
            @change="change(productTypeUidSelected)" filterable></el-cascader> </div>
</template>
<script>
// import cheXingSelect from './cheXing_select.vue';
export default {
    props: [
        'productType_uid_props', // 用于父级参数传递到本页面
        'chanpin_type'
        /* 产品分类的调用类型 
        1 全部调用 
        2 其他类别  
        3 显示商城类别 
        4 显示储值产品类别 
        5 调用完整的4级菜单 */
    ],
    data() {
        return {
            type: 2, // 用于确定显示类型 1 所有的 2 所有已满4级的 3 所有商城的类别
            productTypeUidSelected: 0,
            defaultValue: [],
            editForm: {
                type01_uid: 0,
                type02_uid: 0,
                type03_uid: 0,
                type04_uid: 0,
                product_type01: '',
                product_type02: '',
                product_type03: '',
                product_type04: ''
            },
            editFormControl: 1,
            // 删除按钮是否可见
            // 获取商品类型列表参数
            productTypeList: [],
            // 用于下拉框的数据读取

            //  recordCount: 0,
            total: 0,
            addDialogVisible: false,
            editDialogVisible: false,
            add_isDisable: false,
            //  添加表单数据项
            addForm: {
                C_type: 'productType_add',
                product_changjia: '',
                product_xinghao: '',
                product_xilie: '',
                product_year: '',
                product_port_count: '',
                product_leibie: ''

            },
            productTypeSlectOption: [],
            addFormRules: {

            },
            editFormRules: {},
            show_flag: 0
        };
    },
    watch: {
        productType_uid_props: {
            handler(oldVal, newVal) {
                // this.getDefaultValue(newVal)
            }
        }
        //  productTypeUidSelected: 3
        //  console.log(702, this.productType_uid_props)
        //  this.productTypeUidSelected = this.productType_uid_props // 直接对父级传过来的参数赋值，用于打开修改界面显示的效果不一样，操作保存的query字符不一样
    },
    created() {
        this.productTypeSelect_list();
        // if (this.productType_uid_props !== 0) this.getDefaultValue(this.productType_uid_props)
        // console.log(702, this.productType_uid_props)
    },
    mounted() {

    },
    methods: {
        getDefaultValue(typeData) {
            // console.log(703, uid) 
            // const { data: res } = await this.$http.get('get_api', {
            //     params: {
            //         C_type: 'productTypeSelect_getDefaultValue',
            //         type04: uid
            //     }
            // });
            console.log(7033, typeData)
            console.log(7034, this.$refs.refCascader)
            this.show_flag = 1 // 防止触发change 事件
            this.$refs.refCascader.$refs.panel.checkedValue = typeData
            setTimeout(() => {
                this.show_flag = 0 // 防止触发change 事件
            }, 1000);
        },
        resetSelect() {
            // this.$refs.refCascader.$refs.panel.checkedValue = [0, 0, 0, 0]
            console.log(this.$refs.refCascader.$refs.panel.checkedValue)
            this.$refs.refCascader.$refs.panel.checkedValue = null
            // this.$refs.refCascader.$refs.panel.clearCheckedNodes() 
            // this.$refs.refCascader.$refs.panel.checkedValue = 0;
            // this.productTypeSelectedUid = 0
            // this.$refs.refCascader.clearCheckedNodes()
        },

        // 因为在调用页面修改页中，写了类别数据，show_flag 标记控制
        change(data) {
            if (this.show_flag === 1) return 1
            const areaTextArr = []
            const areaTextArr2 = []
            if (this.$refs.refCascader.getCheckedNodes().length === 0) return
            const arr = this.$refs.refCascader.getCheckedNodes()[0].pathNodes;
            this.productTypeSelectedUid = arr[3].value
            // this.carTypeTishi = '当前选择：' + '[' + arr[0].label + ']' + '[' + arr[1].label + ']' + '[' + arr[2].label + ']' + '[' + arr[3].label + ']'
            // this.getCarTypeSelectedUid(this.carTypeSelectedUid)
            // console.log(990, this.productTypeSelectedUid)
            console.log(7034, arr)
            var data0 = {
                productTypeSelectedUid: this.productTypeSelectedUid,
                pro_chuzhi_flag: this.pro_chuzhi_flag // 返回是否是储值卡的标记，是储值卡，就要显示面值选项，客户在购买时得根据这个面值加到相应账户
            }
            this.$emit('getProductTypeSelectedUid', data0) // 用于向父级页面传递参数
        },
        async productTypeSelect_list() {
            if (this.chanpin_type) this.type = this.chanpin_type
            const { data: res } = await this.$http.get('get_api', {
                params: {
                    C_type: 'productTypeSelect_list',
                    type: this.type
                }
            });
            console.log(JSON.parse(res.data)[0])
            this.productTypeSlectOption = JSON.parse(res.data)[0].data
        }
    }
};
</script>
<style lang="less" scoped>
.productd_two {
    margin-top: 30px;
    box-shadow: none !important;
}

.el_row_two {
    margin-top: 30px;
}

.xiugai {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.el-cascader__item {
    height: 500px;
}

.title {
    font-size: 14px;
    font-weight: 400;
    width: 200px;

}
</style>
